import currencyFormatter from "../../../Helpers/currencyFormatter";
import EmptyItem from "../../comman/EmptyItem";
import { motion } from "framer-motion";



const List = ({ ...props }) => {

  const { data, openCampaignDetails } = props;
  const divAnimate2 = {
    offscreen: { y: 100, opacity: 0 },
    onscreen: {
        y:0,
        opacity: 1,
        transition: {
            type: "spring",
            bounce: 0,
            duration: 1
        }
    }

};
  return (
    <>


      <div className="ms:container ms:mx-auto px-4 ms:px-2">
        <div className='' >
          <>{data?.length > 0 ? (
            data?.map((item, i) => (
              <motion.div key={item?.id} variants={divAnimate2} transition={{ staggerChildren: 0.5 }} initial={"offscreen"} whileInView={"onscreen"} viewport={{ once: true, amount: 0.5 }}  
              key={item?.id} className="p-2  my-2 rounded-lg "
                style={{ "boxShadow": "rgb(210 206 206 / 82%) 3px 5px 20px 1px" }} >

                <div className='flex flex-col md:flex-row'>
                  <img src={item?.campaign?.campaignLogo} alt={item?.campaign?.campaignLogo} onClick={() => { openCampaignDetails(item?.campaign) }} className=" cursor-pointer w-[118px] h-[68px] rounded-lg " ></img>

                  <div className=' w-full flex lg:flex-row flex-col  justify-between md:mx-4 ' >

                    <div className='flex flex-col  justify-between  h-full ' >
                      <div>
                        <h5 onClick={() => { openCampaignDetails(item?.campaign) }} className=" text-lg font-museobb text-gray-500 cursor-pointer">{item?.campaign?.campaign_title}</h5>
                        <h4 className='tracking-wider text-[#178ACB]' >RM {currencyFormatter.format(item?.total_earned)}<span className=' ml-1 text-[8px]  sm:text-xs  text-gray-500 font-museo tracking-normal ' >Total earned</span></h4>
                      </div>
                    </div>
                  </div>

                </div>
              </motion.div>
            ))
          ) : (
          
            <EmptyItem text={'No Payout found'} />
          
          )}</>

        </div>

      </div>

    </>

  )



}

export default List;